<template>
    <div class="d-flex flex-column bg-white rounded position-absolute p-3" id="accountDropdown">
        <span class="font-xxs text-secondary mb-2">Logged in as</span>
        <div class="container d-flex align-items-center p-0 mb-3">
            <img alt="" src="/img/hcpay/user-photo-alt-black.svg" class="userPhoto mb-1">
            <span class="font-sm text-gray-dk text-capitalize text-left">{{ $root.account.personalInformation.firstName }} {{ $root.account.personalInformation.lastName}}</span>
        </div>
        <button type="button" class="btn btn-outline-primary rounded-lg font-sm text-capitalize" @click="$root.logout()">Logout</button>
    </div>
</template>
<script>
export default {
    created() {
        var vm = this;
        document.body.addEventListener('click', function(ev) {
            var accountDropdown = document.getElementById('accountDropdown');
            if(accountDropdown != null && ev.target != accountDropdown && ev.target != document.getElementById('accountDropdownBtn') && !accountDropdown.contains(ev.target)) {
                vm.$parent.showAccountDropdown = false;
            }
        }, false);
    },
}
</script>
<style scoped>
#accountDropdown {
    width: 9rem;
    box-shadow: 0px 4px 12px #00000033;
}
.userPhoto {
    height: auto;
    width: 2rem;
}
</style>